import { MutationTree } from "vuex";
import { CategoryState } from "@/store/category/type";
import { Category } from "@/models/category";

export enum CategoryMutations {
  SET_CATEGORY_TREE = "SET_CATEGORY_TREE",
  GET_ACTIVE_CATEGORY = "GET_ACTIVE_CATEGORY"
}

export const mutations: MutationTree<CategoryState> = {
  [CategoryMutations.SET_CATEGORY_TREE](state, categoryTree: Category): void {
    state.categoryTree = categoryTree;
  },
  [CategoryMutations.GET_ACTIVE_CATEGORY](state, activeCategory: string): void {
    state.activeCategory = activeCategory;
  },

};